import wrap from '@/components/wrap'

export default[
  {
    path:'/',
    name:'首页',
    component: wrap,
    redirect: {
      name: '公告'
    },
    children:[
      {
        path:'notice',
        name:'公告',
        component: () => import('@/views/list')
      },
      {
        path: 'add',
        name: '我要投诉',
        component: () => import('@/views/add')
      },
      {
        path: 'my',
        name: '我的',
        component: () => import('@/views/list')
      },
      {
        path: 'new',
        name: '新投诉',
        component: () => import('@/views/list')
      },
      {
        path: 'transfer',
        name: '已转交',
        component: () => import('@/views/list')
      },
      {
        path: 'reply',
        name: '待回复',
        component: () => import('@/views/list')
      },
      {
        path: 'public',
        name: '待公布',
        component: () => import('@/views/list')
      },
      {
        path: 'detail',
        name: '详情',
        component: () => import('@/views/detail'),
      },
      {
        path: 'receiver',
        name: '接收人管理',
        component: () => import('@/views/receiver'),
      },
      {
        path: 'complaint_type',
        name: '投诉类型管理',
        component: () => import('@/views/complaint_type'),
      },
      {
        path: 'administrator',
        name: '意见箱管理员',
        component: () => import('@/views/administrator'),
      }
    ]
  },
]